{#if type === 'info_block'}
  <div class="info-block">
    <slot></slot>
  </div>
{:elseif type === 'info_block_item'}
  <div class="info-block_item">
    <slot></slot>
  </div>
{:elseif type === 'info_block_title'}
  <div class="info-block_title">
    <slot></slot>
  </div>
{:elseif type === 'info_block_content'}
  <div class="info-block_content">
    <slot></slot>
  </div>
{/if}

<style>
  .info-block {
    display: flex;
    width: 100%;
    margin: 2rem 0;
    @media(max-width: 767px) {
      flex-direction: column;
    }
    @media(min-width: 767px) {
      margin: 3rem 0;
    }
    @media(min-width: 992px) {
      margin: 3.75rem 0;
    }
  }

  .info-block_item {
    flex: 1 0;
    border-top: 1px solid rgba(58, 63, 67, 0.2);
    padding: 2.78rem 2rem 2rem 0;
    @media(min-width: 767px) {
      margin-right: 0.875rem;
      border-bottom: 1px solid rgba(58, 63, 67, 0.2);
    }
    @media(min-width: 992px) {
      margin-right: 1.625rem;
    }
    &:last-child {
      margin-right: 0;
      border-bottom: 1px solid rgba(58, 63, 67, 0.2);
    }
    :global(p:last-child) {
      margin-bottom: 0;
    }
  }

  .info-block_title {
    margin: 0;
    font-size: 2.5rem;
    margin-bottom: 1.65rem;
    color: #de3b48;
    line-height: 1.1;
    letter-spacing: -0.5px;
    @media(min-width: 992px) {
      font-size: 3rem;
    }
    :global(strong) {
      font-size: 1.3em;
      /*font-family: "SolomonBlack";*/
      line-height: 0.83;
      letter-spacing: -0.6px;
      font-weight: 900;
    }
  }

  .info-block_content {
    font-size: 0.875rem;
    line-height: 1.71;
    letter-spacing: -0.2px;
    margin: 0 0 1rem 0;
    color: #0e1522;
    @media(min-width: 992px) {
      font-size: 1rem;
      line-height: 2;
    }
  }
</style>
